import React, { useEffect, useState } from 'react'
import { grey } from '@mui/material/colors';
import Title from '../../components/SharedComponents/Title/index.js';
import SearchBar from '../../components/SharedComponents/SearchBar/index.js';
import ClientsTable from '../../components/Clients/ClientsTable/index.js';
import { notification } from '../../utils/Notifications.js';
import { getCredits } from "../../api/userApi.js";
import useLogout from '../../hooks/auth/authHook.js';

const Clients = () => {
  const [logout] = useLogout();

  const [users, setUsers] = useState([]);
  const [search, setSearch] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    setIsLoading(true);
    getCredits()
      .then((response) => {
        if (response.data.status_Code === 200) {
          setUsers(response.data.clients);
        } else if (response.data.status_Code === 401) {
          notification({
            text: "Sesión expirada. Por favor, inicia sesión nuevamente.",
            type: "error",
          });
          logout();
        } else {
          notification({
            text: "Error al obtener los clientes",
            type: "error",
          });
        }
      })
      .catch(() => {
        notification({ text: "Error de conexión, revisa tu conexión a internet", type: "error" });
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, []);

  return (
    <div style={{ minHeight: "100%", backgroundColor: grey[100], padding: "24px" }}>
      <Title title='Clientes'/>
      <SearchBar setSearch={setSearch}/>
      <ClientsTable
        users={users}
        isLoading={isLoading}
        search={search}
      />
    </div>
  )
}

export default Clients
